import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { Modal } from "@mapmycustomers/ui";

import EmailQueueProgress from "@app/component/EmailQueueModal/EmailQueueProgress";
import EmailQueueSubtitle from "@app/component/EmailQueueModal/EmailQueueSubtitle";
import EmailQueueTable from "@app/component/EmailQueueModal/EmailQueueTable";
import { isEmailQueueVisible } from "@app/store/email";
import { fetchEmailQueue, fetchEmailQuota, hideEmailQueue } from "@app/store/email/actions";
import { RootState } from "@app/store/rootReducer";

import messages from "./messages";

const EmailQueueModal = ({
  onClose,
  onFetchEmailQueue,
  onFetchEmailQuota,
  visible,
}: ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
  const intl = useIntl();

  useEffect(() => {
    if (visible) {
      onFetchEmailQuota();
      onFetchEmailQueue();
    }
  }, [visible, onFetchEmailQueue, onFetchEmailQuota]);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Modal
      destroyOnClose
      footer={<EmailQueueProgress />}
      onCancel={handleCancel}
      open={visible}
      scrollable
      title={
        <div>
          <div>{intl.formatMessage(messages.title)}</div>
          <EmailQueueSubtitle />
        </div>
      }
      width="72rem"
    >
      <EmailQueueTable />
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  visible: isEmailQueueVisible(state),
});

const mapDispatchToProps = {
  onClose: hideEmailQueue,
  onFetchEmailQueue: fetchEmailQueue.request,
  onFetchEmailQuota: fetchEmailQuota.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailQueueModal);
